<template>
  <footer class="footer pt-3 mt-auto container">
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <p class="f-default">
          Desenvolvido por<a
            href="https://www.diazerosecurity.com/"
            class="text-dark"
            target="_blank"
          >
            Diazero Security</a
          >
          © 2021
        </p>
      </div>
      <div class="col-md-6 col-sm-12 d-flex justify-content-end">
        <b-row>
          <b-col cols="12">
            <p class="d-inline-block pr-3 f-default">Siga-nos</p>
            <a
              href="https://www.facebook.com/diazerodz"
              class="d-inline-block btn btn-icon btn-icon-only btn-indigo btn-icon-style-4 pr-2"
              target="_blank"
              ><span class="btn-icon-wrap"><i class="bi bi-facebook"></i></span
            ></a>
            <a
              href="https://twitter.com/diazerosecurity"
              class="d-inline-block btn btn-icon btn-icon-only btn-indigo btn-icon-style-4"
              target="_blank"
              ><span class="btn-icon-wrap"><i class="bi bi-twitter"></i></span
            ></a>
          </b-col>
        </b-row>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  props: [],
  mounted() {},
  data() {
    return {};
  },
  methods: {},
  computed: {},
};
</script>

<style  lang="scss">
.footer {
 height: 60px;
 font-size: 13px;
}
</style>
